import request from '@/plugins/axios';
import {CacheService} from "../service/common";
import OrderService from "./orderService";
import Vue from "vue";
import {CoDepositAuditState, CoDepositAuditStateLabel} from "../service/enum";

export default {

  //保存保证金申请
  addCoDeposit(postData) {
    const {compId} = CacheService.get("comp");
    return request.post(`/Pay/CoDeposit/AddCoDeposit`, {...postData, compId});
  },
  //保证金申请列表
  async getCoDepositList(pager) {
    const {compId} = CacheService.get("comp");
    const res = await request.get(`/Pay/CoDeposit/CoDepositList?pageIndex=${pager.currentPage}&pageSize=${pager.pageSize}`);
    if (!res) return;
    const data = res.data.map(item => {
      if(item.auditStatus == CoDepositAuditState.success){
        item.receiptIssued = item.receiptIssued ? '已开具' : '未开具';
      } else {
        item.receiptIssued = "—";
      }
      return {
        ...item,
        canRevoke: item.auditStatus == CoDepositAuditState.approving,
        canShowMore: item.issueReceipt,
        canShowReceipt: item.receiptIssued,
        payMoney: "￥" + OrderService.toYuan(item.payMoney),
        payPic: Vue.prototype.$fileBaseUrl + '0x32/' + item.payPic,
        previewPayPic: Vue.prototype.$fileBaseUrl + '0x0/' + item.payPic,
        issueReceipt: item.issueReceipt ? '是' : '否',
        
        auditStatus: CoDepositAuditStateLabel[item.auditStatus]
      }
    })
    return {...res, data};
  },
  //撤回保存保证金申请
  revokeCoDeposit(id) {
    return request.post(`/Pay/CoDeposit/RevokeCoDeposit?id=${id}`);
  },

}
